/* eslint-disable react/jsx-no-target-blank */
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuShareholder() {
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Quản lý cổ đông</span>
        </div>
      </div>

      <AsideMenuItem
        to='/sharehoder-management'
        // icon='/media/icons/duotune/general/gen019.svg'
        icon='/media/svg/custom/icn_location.svg'
        title='Quản lý ký số'
        fontIcon='bi-layers'
      />

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
